import { motion } from "framer-motion";
import { forwardRef } from "react";

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`font-mono2 text-xs tracking-[0.3em] uppercase text-[#02AACF] ${className}`}>
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, subtitle, align = "left", light = false }) => (
  <div className={align === "center" ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className={`font-display font-bold tracking-tight mt-3 text-3xl sm:text-4xl lg:text-5xl leading-[1.05] ${light ? "text-[#0F172A]" : "text-white"}`}>
      {title}
    </h2>
    {subtitle && <p className={`mt-4 text-base sm:text-lg leading-relaxed ${light ? "text-slate-600" : "text-[#94A3B8]"}`}>{subtitle}</p>}
  </div>
);

const base =
  "btn-shine inline-flex items-center justify-center gap-2 font-semibold rounded-full transition-all duration-300 active:scale-[0.97] disabled:opacity-50 disabled:pointer-events-none select-none";

const variants = {
  primary: "bg-[#02AACF] text-white hover:bg-[#0288A6] hover:shadow-[0_12px_40px_-10px_rgba(2,170,207,0.7)]",
  outline: "border border-white/25 text-white hover:border-[#02AACF] hover:text-[#02AACF]",
  ghost: "text-white/80 hover:text-white",
  dark: "bg-white text-[#0b0d12] hover:bg-[#02AACF] hover:text-white",
};

const sizes = {
  sm: "text-xs px-4 py-2",
  md: "text-sm px-6 py-3",
  lg: "text-sm sm:text-base px-8 py-4",
};

export const LuxButton = forwardRef(
  ({ variant = "primary", size = "md", className = "", children, ...props }, ref) => (
    <motion.button
      ref={ref}
      whileHover={{ y: -2 }}
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </motion.button>
  )
);
LuxButton.displayName = "LuxButton";

export const revealProps = (delay = 0) => ({
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] },
});
